import React from "react";
import "./styles.css";
import image from "../../Assets/kasyap.jpg";
import Particle from "../Particle";

const Experaince = () => {
  const data = [
    {
      Company: "Surnoi Technology Private Limited",
      Time: "September 2024 - Now",
      Position: "Consultent",
      description:
        "responsible for developing and maintaining software solutions, collaborating with cross-functional teams to deliver high-quality applications, and continuously learning and applying new technologies to enhance software performance and user experience.",
    },
    {
      Company: "Surnoi Technology Private Limited",
      Time: "June 2024 - September 2024",
      Position: "associate software engineer",
      description:
        "responsible for developing and maintaining software solutions, collaborating with cross-functional teams to deliver high-quality applications, and continuously learning and applying new technologies to enhance software performance and user experience.",
    },
    {
      Company: "Blackbuck Engineers Pvt Ltd",
      Time: " March 2024 – May 2024 ",
      Position: "Intern",
      description:
        "• Learnt development of client-side and server-side modules using MERN stack.",
    },
    // {
    //   Company: "swarnandhra college of engineering and technology",
    //   Time: " November 2020 – Augest 2024 ",
    //   Position: "Student",
    //   description:
    //     "CGPA: 8.83/10, B.Tech in Computer Science and Engineering",
    // },
    // {
    //   Company: "Aditya Junior College",
    //   Time: " May 2018 – June 2020 ",
    //   Position: "Student",
    //   description:
    //     "CGPA: 7.34/10, Intermediate in Mathematics, Physics, and Chemistry",
    // },
    // {
    //   Company: "Sunshine High School",
    //   Time: " May 2017 – March 2018 ",
    //   Position: "Student",
    //   description:
    //     "CGPA: 7.5/10, Secondary School Certificate (SSC)",
    // },
  ];

  const images = {
    Highest_Edu: "B.tech in CSE",
    name: "Krishna Kasyap Kanuparthi",
    profission: "Software Engineer",
  };

  const renderTimeline = () => {
    let timelineElements = [];

    // Add the student module first
    timelineElements.push(
      <div className="module profile-module" key="student-module">
        <div className="timeline-bubble">
          <img src={image} alt="User" />
        </div>
        <div className="content-wrapper">
          <div className="content-details">
            <h3>{images.name}</h3>
            <span className="time">{images.profission}</span>
          </div>
        </div>
      </div>
    );

    // Iterate over each data item and generate modules
    data.forEach((item, index) => {
      timelineElements.push(
        <div className="module" key={index}>
          <div className="timeline-bubble">
            <span>{item.Position}</span>
          </div>
          <div className="content-wrapper">
            <div className="content-details">
              <h3>{item.Company}</h3>
              <span className="time">{item.Time}</span>
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      );
    });

    return timelineElements;
  };

  return (
    <div className="timeline-container">
      <Particle/>
      <div className="timeline">{renderTimeline()}</div>
    </div>
  );
};

export default Experaince;
